/*global define*/
/*jshint devel:true*/
/**
 * Base Backbone class generator
 * This is based on the Backbone Deep Model extension.
 * See https://github.com/powmedia/backbone-deep-model#readme for more info
 */
define(
	'BaseClassGenerator',[
		'jquery',
		'backbone',
		'BaseClass'
	],
	function ($, Backbone, BaseClass) {
		'use strict';

		return {
			/**
			 * Generates a generic backbone class for Model, View or Collection
			 * @example
			 * BaseClassGenerator.generate(
			 *  Backbone.Model,
			 *  {
			 *    // some model class def
			 *  },
			 *  {
			 *    // some static model def
			 *  }
			 * );
			 *
			 * @note A mutate() static method will automatically be generated.
			 *
			 * @param {Object} constructorFc This must implement the extend() static method.
			 * @param {Object} [classDef] Class definition (that becomes its prototype)
			 * @param {Object} [staticDef] Class definition (that becomes its static definition)
			 * @return {Object}
			 */
			generate: function (constructorFc, classDef, staticDef) {
				var extClassDef = $.extend(
					{},
					BaseClass,
					classDef || {}
				);

				var extStaticDef = $.extend(
					{
						/**
						 * Mutate the base model definition to another model definition. Useful when using some Backbone plugins.
						 * @example
						 * return BaseModel.mutate(Backbone.DeepModel, {
						 *   className: 'CallSettingsServiceModel',
						 *   defaults: {
						 *    nested: {
						 *       data: {
						 *        sponge: 'bob'
						 *       }
						 *    }
						 *   }
						 * });
						 *
						 * @param {Class} constructor Constructor function from a Backbone Model, View or Collection
						 * @param {Object} options Options hash to extend the class definition.
						 * @return {Class} Returns a Class constructor.
						 */
						mutate: function (constructor, options) {
							return constructor.extend(
								$.extend({}, extClassDef, options)
							);
						}
					},
					staticDef || {}
				);

				return constructorFc.extend(
					extClassDef,
					extStaticDef
				);
			}
		};
	}
);
